import React from "react";

const MobileOptionsBus = (props) => {
  const options = [
    {
      text: 'Qu’est-ce que les paiements sans contact par Débit INTERAC?',
      handler: props.actionProvider.MobileBus1,
      id: 1
    },
    {
      text: 'J’offre déjà le paiement par Débit INTERAC à mes clients. Comment puis-je commencer à offrir les paiements sans contact par Débit INTERAC?',
      handler: props.actionProvider.MobileBus2,
      id: 2
    },
    {
      text: 'J’ai de la difficulté avec mon terminal. Pouvez-vous m’aider?',
      handler: props.actionProvider.MobileBus3,
      id: 3
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container debit-products'>{optionsMarkup}</div>;
};

export default MobileOptionsBus;